import { Component, Host, h, Prop, Event, EventEmitter } from '@stencil/core';
@Component({
  tag: 'cr-tool-link',
  styleUrl: 'cr-tool-link.css',
  shadow: true,
})
export class CrToolLink {
  @Event() toolLinkClicked: EventEmitter<string>;

  @Prop() linkTitle: string;
  @Prop() isValid: boolean;

  render() {
    return (
      <Host>
        <bx-side-nav-link href={this.linkTitle} onClick={this.onClick} class={!this.isValid && 'invalid'}>
          <div class="link-title">{this.linkTitle}</div>
          <div class="icon">{this.icon()}</div>
        </bx-side-nav-link>
      </Host>
    );
  }
  private onClick = (e: Event) => {
    e.preventDefault();
    if (this.isValid) {
      this.toolLinkClicked.emit(this.linkTitle);
    }
  };

  private icon = () => {
    return this.isValid ? <cr-icon-arrow-up-right-from-square size="small"></cr-icon-arrow-up-right-from-square> : <cr-icon-error size="small"></cr-icon-error>;
  };
}
